export default "__VITE_ASSET__D$VRPrR7__"